import React, { useState } from 'react'
import uploadIcon from "../assets/images/uploadeImg.png"
import "../css/UploadIconImage.css"
const UploadImage = ({onChange , forceWidht = false , edit = false , required = false }) => {
    const [imagePreview, setImagePreview] = useState(null);

    const handleImageChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const imageUrl = URL.createObjectURL(file);
        setImagePreview(imageUrl); 
        onChange(event); 
      }
    };
  return  <>
  <div className={forceWidht ? "UploadIconImageFullWidth" : 'UploadIconImage'}>
    <label htmlFor="UploadImage" className='cursor-pointer'>
    {imagePreview ? (
            <img src={imagePreview} alt="uploaded" height={200} className="uploaded-image w-100" />
          ) : (
            <img src={edit ? edit : uploadIcon} className='w-100' alt="uploadIcon" />
          )}
    </label>
    <input type="file" accept='image/*' name="UploadImage" id="UploadImage" onChange={handleImageChange} className='d-none' required={required}/>
  </div>
  <p></p>
  </>
}

export default UploadImage